import { v4 as uuid } from 'uuid'

export interface ICategorySetting {
  foodItems: string,
  nonAlcoholic: string,
  beer: string,
  liquorAndSpirits: string,
  wine: string,
  otherAlcohol: string
}

export interface IVendorSetting {
  [vendorId: string]: {
    quickbooksVendorName: string,
    quickbooksExpenseAccount: string
  } 
}

export interface IQuickbooksSetting {
  id: string
  restaurantCompanyId: string
  categorySettings: ICategorySetting
  vendorSettings: IVendorSetting
}

export class QuickbooksSetting implements IQuickbooksSetting {
  public id: string
  public categorySettings: ICategorySetting = {
    foodItems: '',
    nonAlcoholic: '',
    beer: '',
    liquorAndSpirits: '',
    wine: '',
    otherAlcohol: ''
  }
  public vendorSettings: IVendorSetting = {}

  constructor(public restaurantCompanyId: string) {
    this.id = uuid()
  }

  public isValid(vendorIds: string[] = []) {
    if (!Object.values(this.categorySettings).every((val: string) => val)) {
      return false
    }
    if (!Object.values(this.vendorSettings).every(val => val.quickbooksExpenseAccount && val.quickbooksVendorName)) {
      return false
    }
    if (!vendorIds.every(id => this.vendorSettings[id])) {
      return false
    }

    return true
  }
}
